@let multiSelectValue = multiSelectValueSg();
@let singleSelectValue = singleSelectValueSg();

@if (multiSelectValue) {
  <atn-list-content [value]="multiSelectValue" />
} @else if (singleSelectValue) {
  <atn-ds-tag [text]="singleSelectValue" />
}
